import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import { ElementAddress } from 'editor/src/store/design/types';
import { getTextFlowChainOf, setTextFlowChainText } from 'editor/src/store/design/util/textFlow';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import flowLinkedTextsOperation from './flowLinkedTextsOperation';
import updateMediaElementOperation, { MediaUpdateActionName } from './updateMediaElementOperation';

/**
 * Writes the buyer's value for a chain of linked frames, which is one field (getTextFlowFieldText),
 * and pours it at once, so no frame shows the whole value in between. Returns false for a text
 * that is not in a chain, which the caller writes as usual.
 */
const setTextFlowFieldTextOperation =
  (address: ElementAddress, uuid: number, text: string, preventSavingStore: boolean) =>
  (dispatch: ThunkDispatch, getState: () => RootState) => {
    const chain = getTextFlowChainOf(getState().design.designData, address.spreadIndex, uuid);
    if (!chain || chain.length < 2) {
      return false;
    }
    batch(() => {
      // through the operation, so the first frame's value format and sample flag apply to the value
      setTextFlowChainText(chain, text).forEach(({ address: frameAddress, update }, index) =>
        dispatch(
          updateMediaElementOperation(
            frameAddress,
            update,
            MediaUpdateActionName.TEXT_UPDATED,
            preventSavingStore || index > 0,
          ),
        ),
      );
      dispatch(flowLinkedTextsOperation());
    });
    return true;
  };

export default setTextFlowFieldTextOperation;
